setTimeout(function () {
    //$(".gocompare.v2 :checkbox").labelauty({
    //    label: false
    //});
}, 2000);

initComparator();
mobileInitComparator();


function initComparator() {
    jQuery('span.yes').click(function (e) {
        e.preventDefault();
        var i = 1;
        var url = "/?";
        jQuery('.gocompare').each(function () {
            if (jQuery(this).find('input[type=checkbox]').is(':checked')) {
                url = url + "p" + i + "=" + jQuery(this).find("input[type=hidden][name='productCode']").attr('value') + "&";
                i++;
            }
        });
        var root = jQuery('.gocompare span.yes').attr('data-href');
        document.location.href = root + url;
    });
    initMatchCompare();
    jQuery('.product-comparator .close').on('click', function () {
        initMatchCompare();
    });
}

function mobileInitComparator() {
    jQuery('.gocompareBtn a.btn').click(function (e) {
        e.preventDefault();
        var i = 1;
        var url = "/?";
        jQuery('.gocompare').each(function () {
            if (jQuery(this).find('input[type=checkbox]').is(':checked')) {
                url = url + "p" + i + "=" + jQuery(this).find("input[type=hidden][name='productCode']").attr('value') + "&";
                i++;
            }
        });
        var root = jQuery('.gocompare span.yes').attr('data-href');
        document.location.href = root + url;
    });
    initMatchCompare();
    jQuery('.product-comparator .close').on('click', function () {
        initMatchCompare();
    });
}

function initMatchCompare() {
    var check = false;
    var value = "";
    jQuery('#ScrollabeTableCompare tbody tr').each(function () {
        jQuery(this).children('.datas').each(function (index) {
            if (value == "") {
                value = jQuery(this).text();
            }
            if ((value != jQuery(this).text()) || (check == true)) {
                check = true;
            }
        });

        if (check != true && !jQuery(this).hasClass("comparison")) {
            jQuery(this).addClass("ressemblant");
        }
        value = "";
        check = false;
    });
}




